import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ListTableComponent } from '@ppl/ui';
import { NgZorroModule } from '../../../../shared/modules/ng-zorro/ng-zorro.module';
import { LeadDetailsService } from '../../../../services/lead-details.service';
import { LoggerService } from '../../../../shared/services/logger.service';

@Component({
  selector: 'ppl-lead-pmpm-list',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, NgZorroModule, ListTableComponent],
  templateUrl: './lead-pmpm-list.component.html',
  styleUrl: './lead-pmpm-list.component.css',
})
export class LeadPmpmListComponent implements OnInit, OnChanges {
  @Input() programCode = '';
  @Input() selectedLeadId: any;

  gridData: any[] = [];
  isLoaded = false;

  cols = [
    { field: 'language', header: 'Language', jsonpath: 'language', isDisplayedAtHeader: 'y', isSearchable: 'n' },
    { field: 'fms_model', header: 'FMS Model', jsonpath: 'fms_model', isDisplayedAtHeader: 'y', isSearchable: 'n' },
    { field: 'provider_count', header: 'Provider Count', jsonpath: 'provider_count', isDisplayedAtHeader: 'y', isSearchable: 'n' },
    { field: 'tier', header: 'Tier', jsonpath: 'tier', isDisplayedAtHeader: 'y', isSearchable: 'n' },
    { field: 'start_date', header: 'Start Date', jsonpath: 'start_date', isDisplayedAtHeader: 'y', isSearchable: 'n' },
    { field: 'end_date', header: 'End Date', jsonpath: 'end_date', isDisplayedAtHeader: 'y', isSearchable: 'n' },
    { field: 'comments', header: 'Comments', jsonpath: 'comments', isDisplayedAtHeader: 'y', isSearchable: 'n' },
  ];

  constructor(
    private leadDetailsService: LeadDetailsService,
    private logger: LoggerService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if ((changes['programCode'] || changes['selectedLeadId']) && this.programCode && this.selectedLeadId) {
      this.loadPmpmData();
    }
  }

  loadPmpmData(): void {
    const payload = {
      pageName: 'pmpm_list',
      programCode: this.programCode,
      condition: 'and',
      recordsPerPage: 20,
      startingPageNumber: '1',
      orderByColumn: ['id'],
      orderBy: ['desc'],
      searchParam: [
        {
          jsonPath: 'participant_id',
          value: this.selectedLeadId,
          operator: 'Equal',
        },
      ],
    };

    this.leadDetailsService.getFmsData(payload).subscribe({
      next: (response: any) => {
        this.gridData = response?.responsedata ?? [];
        this.isLoaded = true;
        this.cdr.markForCheck();
      },
      error: (err) => {
        this.logger.info('Error fetching PMPM data', err);
        this.isLoaded = true;
        this.cdr.markForCheck();
      },
    });
  }
}
